vakinn = window.vakinn || {};

vakinn.util = {};
vakinn.util.copyLinkToClipboard = function (element) {
	var $temp = $("<input>");
	$("body").append($temp);
	$temp.val($(element).attr('href')).select();
	document.execCommand("copy");
	$temp.remove();
	return false;
};

vakinn.company = {};
vakinn.company.list = {};
vakinn.company.list.init = function () {
	$('.vakinn .search-panel .checkbox select').change(function () {
		$('form.search').submit();
	});
	vakinn.sortBy.init();
};
vakinn.company.view = {};
vakinn.company.view.init = function () {
	(function($,window,undefined) {
		$.fn.inlineEdit = function(options) {
			return this.each(function () {
				var $this = $(this);
				var $inlineShow = $(this).find('.inline-show');
				var $inlineEdit = $(this).find('.inline-edit');
				var $inlineToggle = $(this).find('.inline-toggle');
				var $inlineCancel = $(this).find('.inline-cancel');

				$this.find('form').vakinnform({
					allowRedirect: false,
					afterSuccess: function (elm, result) {
						if (result.extra.hasOwnProperty('redirect') && result.extra.redirect) {
							window.location.replace(result.extra.redirect);
						}
						$this.find('.inline-show').html(result['extra']['html']);
						inlineShow();
						return false;
					}
				});

				$inlineCancel.click(function () {
					inlineShow();
					return false;
				});

				function inlineShow() {
					$inlineEdit.hide('fast');
					$inlineShow.show();
				}

				function inlineEdit() {
					$inlineShow.hide();
					$inlineEdit.show('fast');
				}

				$inlineToggle.click(function () {
					if($inlineShow.is(':visible')) {
						inlineEdit();
					}
					else {
						inlineShow();
					}
					return false;
				});
			});
		};
	}(jQuery, window));

	$('div.company-options').inlineEdit();
	$('div.company-status').inlineEdit();

	$('a.evaluation-list-year').click(function () {
		var year = $(this).data('year');
		var itemClass = 'li.evaluation-list-item-year-' + year;
		$(this).parent().parent().find(itemClass).toggle();
		return false;
	});

	/* COMMENTS */
	$('.modal-action').click(function () {
		var $anchor = $(this);
		$.get($anchor.attr('href'), function (data) {
			var $modal = $('#company-modal');
			$modal.find('.modal-body').html(data);
			$modal.find('form').prop('action', $anchor.attr('href'));
			$modal.find('h4').html($anchor.data('modaltitle'));
			$modal.modal();
		},'json');
		return false;
	});
	$('#company-modal').find('.save').click(function () {
		$('#company-modal').find('form').submit();
	});

	$('.company-attachments .nav-item a').click(function () {
		var $attachmentTabs = $('.attachment-tab');
		var divClass = '.' + $(this).attr('rel');
		$attachmentTabs.hide();
		console.log(divClass);
		$(divClass).show();
	});

	var $reportPanel = $('.company-current-evaluation .panel-body');
	var reportUrl = $reportPanel.data('url');

	if (reportUrl) {
		$.ajax(reportUrl, {
			dataType: 'json',
			success: function (data,status,xhr) {
				$reportPanel.html(data);
			},
			error: function (jqXhr, textStatus, errorMessage) { // error callback
				$reportPanel.html('Error: ' + errorMessage);
			}
		});
	}

	$('.position-browse').click(function(event) {
		event.preventDefault();
		var url = $(this).attr('href');
		$.get(url, function (data) {
			var $modal = $('#positionBrowseModal');
			// Init search features
			$modal.find('.modal-body').html(data);
			var $form = $modal.find('form.search');
			var $button = $form.find('button');
			var $input = $form.find('input');
			var $select = $form.find('select');
			var $results = $modal.find('.position-results');

			$button.click(function () {
				event.preventDefault();
				$.get($form.attr('action'), {q: $input.val(), p: $select.val()}, function (data) {
					$results.html(data);
				}, 'json');
				return false;
			});
			$modal.modal();
		}, 'json');

		return false;
	});

	$('.position-attach').live('click', function () {
		var $this = $(this);
		$.get($(this).attr('href'), function (data) {
			$('.company-position-list').append(data);
			$this.parent().parent().parent().remove();
		});

		return false;
	});

	$('.position-detach').live('click', function () {
		var $this = $(this);
		$.get($(this).attr('href'), function () {
			$this.parent().parent().parent().remove();
		});

		return false;
	});
};
vakinn.evaluation = {};
vakinn.evaluation.edit = {};
vakinn.evaluation.edit.activeTab = null;
vakinn.evaluation.edit.autosaveTimeout = 60000 * 3; // 3 minutes
vakinn.evaluation.edit.enableLocking = 0;
vakinn.evaluation.edit.currentAttachments = null;
vakinn.evaluation.edit.currentNote = null;
vakinn.evaluation.edit.currentNoteButton = null;
vakinn.evaluation.edit.init = function () {
	$('[data-toggle="popover"]').popover();
	var items = {
		"note": {name: "Skrá minnispunkt", icon: "fa-sticky-note"},
		"comment": {name: "Skrá athugasemd", icon: "fa-comment"}
	};

	$.contextMenu({
		selector: '.context-menu-one',
		trigger: 'left',
		callback: function(key, options) {
			if (key === 'locked') {
				vakinn.evaluation.edit.lock($(this));
			}
			else {
				vakinn.evaluation.edit.addChapterComment($(this), key);
			}
		},
		items: items
	});

	$('#evaluation').vakinnform({
		allowRedirect: false,
		showSplash : true
	});

	// Calculate score
	$('.chapter').each(function () {
		vakinn.evaluation.edit.updateChapterCurrentTotal($(this));
	});

	$('div.value :radio').change(function () {
		var $label = $(this).parent();
		var $group = $label.parent();
		var $chapter = $group.parent().parent();
		var number = $(this).data('number');
		var parentNumber = $(this).data('parentnumber');
		if(parentNumber !== undefined) {
			var $children = $('.parent' + parentNumber).not('.number' + number);
			$children.find('label').each(function () {
				var $input = $(this).find('input');
				$input.prop('checked', false);
				$(this).removeClass('active');
				$(this).removeClass('btn-' + $(this).attr('active-class'));
				$(this).addClass('btn-default');
				if($input.val() === '2') {
					$input.prop('checked', true);
					$(this).addClass('active');
				}
			});
		}

		$group.find('label').attr('class', 'btn btn-default');
		if($(this).is(':checked')) {
			$label.attr('class', 'btn btn-' + $label.attr('active-class'));
		}

		if (vakinn.evaluation.edit.enableLocking) {
			var $lockedInput = $group.parent().find('.locked-input');
			if ($lockedInput.val() === '1' && $(this).val() !== '1') {
				$group.parent().find('div.lock').hide();
				$lockedInput.val(0);
			}
		}

		vakinn.evaluation.edit.updateChapterCurrentTotal($chapter);
	});

	$('.allow-zero-points').click(function () {
		$(this).toggleClass('btn-success btn-warning');
		var criteria = $(this).parent().data('criteria');
		var id = '#zero-points-' + criteria;
		$(id).val($(this).hasClass('btn-success') ? 0 : 1);

		var $chapter = $(this).parent().parent().parent();
		vakinn.evaluation.edit.updateChapterCurrentTotal($chapter);
	});

	$('button#cancel').click(function () {
		history.go(-1);
	});

	$('.attachments-edit').click(function() {
		var $this = $(this);
		vakinn.evaluation.edit.currentAttachments = $this;
		$.get($this.data('url'), function (data) {
			var $modal = $('#attachmentsModal');
			$modal.find('.modal-body').html(data);
			vakinn.evaluation.attachments.init({
				"uploader":"\/_moya\/js\/jquery\/uploadify\/uploadify.swf",
				"script":"\/_\/kerfi\/vakinn\/evaluation\/attach",
				"cancelImg":"\/_moya\/js\/jquery\/uploadify\/cancel.png",
				"editMultiple":"\/kerfi\/album\/editmultiple"
			}, {
				"galleryImageUploadFileDescription":"Myndir (*.jpg, *.gif, *.png)",
				"galleryImageBrowse":"Drag\u00f0u skr\u00e1r hinga\u00f0 inn e\u00f0a smelltu til a\u00f0 velja",
				"galleryErrorOnSave":"Gat ekki skrifa\u00f0 \u00ed gagnagrunn",
				"galleryErrorNoAlbumName":"Ekkert nafn gefi\u00f0 \u00e1 alb\u00fam"
			});
			$modal.on('hidden.bs.modal', function () {
				vakinn.evaluation.edit.currentAttachments
					.find('.attachment-count')
					.text($modal.find('.attachment-list > div').length);
			});
			$modal.modal();
		}, 'json');

		return false;
	});

	var $criteriaNoteModal = $('#criteriaNoteModal');
	var $textArea = $criteriaNoteModal.find('#criteriaNoteTextarea');

	$criteriaNoteModal.on('hidden.bs.modal', function () {
		var value = $textArea.val();
		vakinn.evaluation.edit.currentNote.val(value);
		vakinn.evaluation.edit.currentNoteButton
			.find('.criteria-note-count')
			.text(value ? '🞹' : '');
	});

	$criteriaNoteModal.on('shown.bs.modal', function () {
		$textArea.focus();
	});

	$('.criteria-note-edit').click(function() {
		vakinn.evaluation.edit.currentNoteButton = $(this);
		vakinn.evaluation.edit.currentNote = $(this).parent().parent().find('.criteria-note');
		$textArea.val(vakinn.evaluation.edit.currentNote.val());
		$criteriaNoteModal.modal();

		return false;
	});

	// Autosave
	setInterval('vakinn.evaluation.edit.autosaveEvaluation()', vakinn.evaluation.edit.autosaveTimeout);
};

vakinn.evaluation.edit.autosaveEvaluation = function () {
	if (typeof console === "object") {
		console.log('saving')
	}
	var $submit = $('#submitForm');
	$submit.addClass('skipSplash');
	$('#evaluation').submit();
	$submit.removeClass('skipSplash');
};
vakinn.evaluation.edit.lock = function ($element) {
	var $parent = $element.parent().parent().parent();
	var $lockedInput = $parent.find('.locked-input');
	var $lockIcon = $parent.find('div.lock');
	var currentValue = $lockedInput.val();
	if (currentValue === '0') {
		$lockedInput.val('1');
		$parent.find(':input:radio:first').prop('checked', true).trigger('change');
		$lockIcon.show();
	}
	else {
		$lockedInput.val('0');
		$lockIcon.hide();
	}
};
vakinn.evaluation.edit.addChapterComment = function($element, type) {
	var title = $element.parent().parent().parent().find('.title').text();
	var text = $element.text() + " " + title;

	var $chapterComment = $element.closest('ul').find('.chapter-comment-priority-' + type);
	if($chapterComment.val() !== '') {
		text = "\n" + text;
	}

	var currentText = $chapterComment.val();
	$chapterComment.focus().val('').val(currentText + text + "\n");

	var lines = [];

	$.each($chapterComment.val().split(/^(?=[0-9]{3}-[0-9]+\.[0-9]+)/gm), function (i,k) {
		lines.push(k.replace(/^\s+|\s+$/g, ''));
	});

	var expr = /[0-9]{3}-[0-9]+\.([0-9]+)/;
	lines.sort(function(a,b) {
		var matchA = expr.exec(a.replace('*', ''));
		var matchB = expr.exec(b.replace('*', ''));
		return parseInt(matchA[1])-parseInt(matchB[1]);
	});

	$chapterComment.val(lines.join("\n\n"));
};

vakinn.evaluation.edit.updateChapterCurrentTotal = function ($chapter) {
	var total = 0;
	$chapter.find(':radio').each(function () {
		if($(this).val() === '1' && $(this).is(':checked') && $(this).parent().parent().find('.zero-points').val() == 0) {
			total += parseInt($(this).data('points'));
		}
	});
	$chapter.find('.current').html(total);
	// Chapter Title div
	$chapter.prev().find('.current').html(total);
};

vakinn.evaluation.attachments = {
	urls: {},
	lang: {},
	init: function(urls, lang) {
		moya.gallery.upload.urls = urls;
		moya.gallery.upload.lang = lang;

		$('#attachments').uploadify({
			uploader: urls.uploader,
			script: urls.script,
			cancelImg: urls.cancelImg,
			auto: true,
			multi: true,
			folder: '/tmp',
			fileDesc: lang.galleryImageUploadFileDescription,
			fileExt: '*.jpg;*.jpeg;*.gif;*.png;*.JPG;*.JPEG;*.GIF;*.PNG;*.pdf;*.PDF;.docx;.xlsx;.csv;.txt;.zip',
			buttonText: lang.galleryImageBrowse,
			onError: function () {
				$('#notice').html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
			},
			onComplete: function(e,q,f,r) {
				var n = $('#notice');
				switch(r) {
					case 'noAlbum':
						n.html('<div class="message"><div class="error">' + lang.galleryErrorNoAlbumName + '</div></div>');
						break;
					case 'noSave':
						n.html('<div class="message"><div class="error">' + lang.galleryErrorOnSave + '</div></div>');
						break;
					default:
						n.html('');
						var j = jQuery.parseJSON(r);
						$('.attachment-list').append(j.html);
						break;
				}
			},
			onAllComplete: function(){
				$('#imageNew #submit').removeAttr('disabled');
			},
			onSelect: function() {
				var data = {
					'albumId' : $('#imageNew #albumId').val(),
					'userId' : $('#imageNew #userId').val()
				};
				$('#attachments').uploadifySettings('scriptData', data);
			}
		});

		$('.attachment-delete').live('click', function () {
		    var $this = $(this);
			vakinn.evaluation.attachments.detach($this.data('attachmentid'), $this.attr('href'));
            $this.parent().remove();
			return false;
		});
	},
	detach: function (id, url) {
		$.post(url, {id : id}, function(data) {
			return data.success;
		},'json')
	}
};

vakinn.evaluation.report = {};
vakinn.evaluation.report.init = function () {
	$('[data-toggle="popover"]').popover();

	// Scope results
	$('.scope-results-edit').click(function() {
		var $form = $('#scopeResultsForm');
		var $element = $('#scope_results');
		$element.val($('div.scope-results').text());

		$form.attr('action', $(this).attr('href'));
		$('#scopeResultsModal').modal();

		return false;
	});

	$('#scopeResultsSave').click(function () {
		$('#scopeResultsForm').submit();
	});

	// Scope results
	$('.scope-general-edit').click(function() {
		var $form = $('#scopeGeneralForm');
		var $element = $('#scope_general');
		$element.val($('div.scope-general').text());

		$form.attr('action', $(this).attr('href'));
		$('#scopeGeneralModal').modal();

		return false;
	});

	$('#scopeGeneralSave').click(function () {
		$('#scopeGeneralForm').submit();
	});

	// Chapter comments
	$('.comment-edit').click(function() {
		$('#comment').val($(this).parent().parent().find('.comment-original').val());
		var label = $(this).parent().parent().find('.comment-key').html();
		var $commentForm = $('#commentForm');
		$commentForm.find('label').text(label);
		$commentForm.attr('action', $(this).attr('href'));
		$('#commentModal').modal();

		return false;
	});

	$('#commentSave').click(function () {
		$('#commentForm').submit();
	});

	$('.comment-delete').click(function() {
		$('#commentDeleteForm').attr('action', $(this).attr('href'));
		$('#commentDeleteModal').modal();

		return false;
	});

	$('#commentDelete').click(function () {
		$('#commentDeleteForm').submit();
	});

	$('.certification-report .report-toggle').click(function () {
		$(this).parent().parent().parent().find('.list-group').toggle();
	})
};

vakinn.user = {};
vakinn.user.criteria = {};
vakinn.user.criteria.init = function () {
	// Calculate score
	$('.chapter').each(function () {
		var total = 0;
		$(this).find(':radio').each(function () {
			if($(this).val() == '1' && $(this).is(':checked')) {
				total += parseInt($(this).data('points'));
			}
		});
		$(this).find('.current').html(total);
		// Chapter Title div
		$(this).prev().find('.current').html(total);
	});
};

vakinn.criteria = {};
vakinn.criteria.chapter = {};
vakinn.criteria.chapter.edit = {};

vakinn.criteria.chapter.edit.subjectNumber = null;
vakinn.criteria.chapter.edit.chapterNumber = null;
vakinn.criteria.chapter.edit.startNumber = null;

vakinn.criteria.chapter.edit.init = function () {
	$('input.delete-criteria').live('click', function () {
		$(this).closest('tr').toggleClass('deleted', $(this).is(':checked'))
	})
	return false
};

vakinn.checklist = {};
vakinn.checklist.init = function () {
	$('.checklist-form .radio').live('click', function () {
		var $radio = $(this);
		var $item = $radio.parent().parent().parent();
		var isOther = $item.find('.other').length > 0;
		var $printable = $item.find('.check .printable');
		var projectLabel = $item.find('.item-number').text() + ' ';
		projectLabel += (isOther) ? $item.find('.text').val().trim() : $item.find('.item-label').text().trim();

		$printable.each(function () {
			if($(this).data('value') == $radio.val()) {
				$(this).html('&#9745;'); // Checked box
			}
			else {
				$(this).html('&#9744;'); // Unchecked box
			}
		});

		var $projectInputs = $('.project-table .project .text');

		// Clear current
		$projectInputs.each(function () {
			if($(this).val() == projectLabel) {
				$(this).val('').trigger('blur');
				$(this).parent().parent().parent().find('.printable').html('');
				$(this).parent().parent().parent().find('.text').val('');
				return false;
			}
		});

		// Copy text
		if($radio.val() == 3) { // Requires attention
			var hasEmptyLine = false;
			$projectInputs.each(function () {
				if($(this).val() == '') {
					$(this).val(projectLabel).trigger('blur');
					$(this).parent().parent().find('.printable').html(projectLabel);
					hasEmptyLine = true;
					return false;
				}
			});
			if (!hasEmptyLine) {
				// No empty lines found, need to create a new one
				vakinn.checklist.addProjectLine(projectLabel);
			}
		}


	});

	$('a.add-project-line').click(function () {
		vakinn.checklist.addProjectLine();
		return false;
	});

	$('.checklist-form .text').live('blur', function () {
		var value = $(this).val();
		var $parent = $(this).parent().parent();
		$parent.find('.printable').text(value);
	});

	$('.checklist-form .print').click(function () {
		$('.checklist-form').toggleClass('write print');

		var status = $(this).data('status');
		if(status == 'writable') {
			$(this).val('Sjá eyðublað');
			$('.checklist-form .writable').hide();
			$('.checklist-form .printable').show();
			$(this).data('status', 'printable');
		}
		else {
			$(this).val('Sjá prentvæna útgáfu');
			$('.checklist-form .writable').show();
			$('.checklist-form .printable').hide();
			$(this).data('status', 'writable');
		}
	});

	$('.checklist-form .other input').focus(function () {
		if($(this).val() == 'Annað – skrá hér.') {
			$(this).val('');
		}
	}).blur(function () {
		if($(this).val() == '') {
			$(this).val('Annað – skrá hér.');
		}
	});
};

vakinn.checklist.addProjectLine = function (text) {
	var $projectsRows = $('.project-table .project-row');
	var length = $projectsRows.length;
	var namePrefix = 'a[' + length + ']';
	var $new = $projectsRows.last().clone();
	text = (text) ? text : '';
	$new.find('input.p').attr('name', namePrefix + '[p]').val(text);
	$new.find('input.pec').attr('name', namePrefix + '[pec]').val('');
	$new.find('input.pac').attr('name', namePrefix + '[pac]').val('');
	$new.find('input.pc').attr('name', namePrefix + '[pc]').val('');
	$new.find('div.printable').html('');
	$new.find('div.printable:first').html(text);
	$('.project-table tbody').append($new);
};

vakinn.criteria.subject = {};
vakinn.criteria.subject.form = {};
vakinn.criteria.subject.form.init = function () {
	$('#type').change(function () {
		vakinn.criteria.subject.form.toggleAccommodation();
	});
	vakinn.criteria.subject.form.toggleAccommodation();
};
vakinn.criteria.subject.form.toggleAccommodation = function () {
	if($('#type').val() === 'accommodation') {
		$('#elm_acc').show();
	}
	else {
		$('#elm_acc').hide();
	}
};

vakinn.participants = {};
vakinn.participants.init = function () {
	xOffset = 10;
	yOffset = 30;
	var $preview = $("a.preview");
	$preview.hover(function(e){
			this.t = this.title;
			this.title = "";
			var c = (this.t != "") ? "<br/>" + this.t : "";
			$("body").append("<p id='part-preview'><img src='"+ this.href +"' alt='Image preview' />"+ c +"</p>");
			$("#part-preview")
				.css("top",(e.pageY - xOffset) + "px")
				.css("left",(e.pageX + yOffset) + "px")
				.fadeIn("fast");
		},
		function(){
			this.title = this.t;
			$("#part-preview").remove();
		});
	$preview.mousemove(function(e){
		$("#part-preview")
			.css("top",(e.pageY - xOffset) + "px")
			.css("left",(e.pageX + yOffset) + "px");
	});
	$('ul.pick-type .checkbox').click(function () {
		var typeClass = $(this).attr('id');
		var available = ['general', 'hotel', 'guesthouse', 'private-home', 'campsite', 'summerhouse', 'hostel', 'environment', 'cafe'];
		var selected = [];
		$.each(available, function (i, k) {
			if($('#' + k).is(':checked')) {
				selected.push(k);
			}
		});

		var counter = 0;
		var even = true;
		$('table.thlist tr').each(function () {
			var $tr = $(this);
			$tr.hide();
			$tr.removeClass('even');
			$.each(selected, function (i, k) {
				if($tr.hasClass(k) && !$tr.is(':visible')) {
					$tr.show();
					if(even) {
						$tr.addClass('even');
						even = false;
					}
					else {
						even = true;
					}
					counter += 1;
				}
			});
		});
		$('span.count').html(counter);
	})
};

vakinn.sortBy = {};
vakinn.sortBy.init = function () {
	/* sortBy functions & helpers extracted and slightly modified from
	 * Sugar Library v1.3.7
	 * Freely distributable and licensed under the MIT-style license.
	 * Copyright (c) 2012 Andrew Plummer
	 * http://sugarjs.com/arrays#sorting
	 */
	var array = {
			AlphanumericSortIgnoreCase  : true,
			AlphanumericSortEquivalents : {}
		},

		order = 'AÁBCDÐEÉĘFGHIÍJKLMNOÓPQRSTUÚVWXYÝZÞÆÖ',
		equiv = '',

		sortBy = function(a,b){
			return typeof a === "string" && typeof b === "string" ? collateStrings(a,b) : a < b ? -1 : a > b ? 1 : 0;
		},

		// Alphanumeric collation helpers
		collateStrings = function(a, b) {
			var aValue, bValue, aChar, bChar, aEquiv, bEquiv, index = 0, tiebreaker = 0;
			a = getCollationReadyString(a);
			b = getCollationReadyString(b);
			do {
				aChar  = getCollationCharacter(a, index);
				bChar  = getCollationCharacter(b, index);
				aValue = getCollationValue(aChar);
				bValue = getCollationValue(bChar);
				if (aValue === -1 || bValue === -1) {
					aValue = a.charCodeAt(index) || null;
					bValue = b.charCodeAt(index) || null;
				}
				aEquiv = aChar !== a.charAt(index);
				bEquiv = bChar !== b.charAt(index);
				if (aEquiv !== bEquiv && tiebreaker === 0) {
					tiebreaker = aEquiv - bEquiv;
				}
				index += 1;
			} while (aValue != null && bValue != null && aValue === bValue);
			if (aValue === bValue) return tiebreaker;
			return aValue < bValue ? -1 : 1;
		},

		getCollationReadyString = function(str) {
			if (array.AlphanumericSortIgnoreCase) {
				str = str.toLowerCase();
			}
			return str.replace(array.AlphanumericSortIgnore, '');
		},

		getCollationCharacter = function(str, index) {
			var chr = str.charAt(index), eq = array.AlphanumericSortEquivalents || {};
			return eq[chr] || chr;
		},

		getCollationValue = function(chr){
			var order = array.AlphanumericSortOrder;
			return chr ? order.indexOf(chr) : null;
		},

		equivalents = {};

	array.AlphanumericSortOrder = $.map(order.split(''), function(str) {
		return str + str.toLowerCase();
	}).join('');

	$.each(equiv.split(','), function(i,set) {
		var equivalent = set.charAt(0);
		$.each(set.slice(1).split(''), function(i,chr) {
			equivalents[chr] = equivalent;
			equivalents[chr.toLowerCase()] = equivalent.toLowerCase();
		});
	});

	$.extend($.tablesorter.themes.bootstrap, {
		// these classes are added to the table. To see other table classes available,
		// look here: http://twitter.github.com/bootstrap/base-css.html#tables
		table      : 'table table-bordered',
		caption    : 'caption',
		header     : 'bootstrap-header', // give the header a gradient background
		footerRow  : '',
		footerCells: '',
		icons      : '', // add "icon-white" to make them white; this icon class is added to the <i> in the header
		sortNone   : 'bootstrap-icon-unsorted',
		sortAsc    : 'icon-chevron-up glyphicon glyphicon-chevron-up',     // includes classes for Bootstrap v2 & v3
		sortDesc   : 'icon-chevron-down glyphicon glyphicon-chevron-down', // includes classes for Bootstrap v2 & v3
		active     : '', // applied when column is sorted
		hover      : '', // use custom css here - bootstrap class may not override it
		filterRow  : '', // filter row class
		even       : '', // odd row zebra striping
		odd        : ''  // even row zebra striping
	});

	// call the tablesorter plugin and apply the uitheme widget
	$("table").tablesorter({
		theme : "bootstrap",
		widthFixed: true,
		headerTemplate : '{content} {icon}', // new in v2.7. Needed to add the bootstrap icon!
		widgets : [ "uitheme", "zebra" ],
		widgetOptions : {
			zebra : ["even", "odd"],
			filter_reset : ".reset"
		},
		textSorter: sortBy,
		dateFormat: "dd/mm/yyyy"
	});
};
vakinn.partner = {};
vakinn.partner.init = function () {
	$('#elm_companies input').change(function () {
		var $elm  = $(this);
		if ($elm.attr('id') === 'companies-0') {
			$elm.parent().parent().find('input:not(#companies-0)').prop('checked', $elm.prop('checked'));
		}
	});
	$('#elm_certifications input').change(function () {
		var $elm  = $(this);
		if ($elm.attr('id') === 'certifications-0') {
			$elm.parent().parent().find('input:not(#certifications-0)').prop('checked', $elm.prop('checked'));
		}
	});
};
